import { render, staticRenderFns } from "./Traceability.vue?vue&type=template&id=c929ab62&"
import script from "./Traceability.vue?vue&type=script&lang=js&"
export * from "./Traceability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports